import * as React from 'react';
import {Slot} from '@radix-ui/react-slot';
import {cva, type VariantProps} from 'class-variance-authority';

import {cn} from '../lib/utils';

// Unset axes inherit from the parent, so Text can restyle one property only.
const textVariants = cva('', {
  variants: {
    size: {
      xxs: 'text-xxs',
      xs: 'text-xs',
      sm: 'text-sm',
      base: 'text-base',
      '2xl': 'text-2xl',
    },
    tone: {
      default: 'text-foreground',
      muted: 'text-muted-foreground',
    },
    weight: {
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
    },
    numeric: {
      true: 'tabular-nums',
    },
    truncate: {
      true: 'truncate',
    },
  },
});

export interface TextProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof textVariants> {
  asChild?: boolean;
}

const Text = React.forwardRef<HTMLSpanElement, TextProps>(
  (
    {className, size, tone, weight, numeric, truncate, asChild, ...props},
    ref,
  ) => {
    const Comp = asChild ? Slot : 'span';
    return (
      <Comp
        ref={ref}
        className={cn(
          textVariants({size, tone, weight, numeric, truncate}),
          className,
        )}
        {...props}
      />
    );
  },
);
Text.displayName = 'Text';

export {Text, textVariants};
